//#region STATUS COLORS
// Tailwind classes per order status, used by OrderStatusControl for the pill +
// dropdown. Hues reuse the existing badge mapping (Pending=yellow, Ordered=green,
// Shipped=blue, Cancelled=red) with In progress=amber and Created=pink added.
// Class strings are literal so Tailwind's JIT picks them up.
export function statusColorByName(name: string): {
  bg: string;
  text: string;
  fill: string;
} {
  switch (name.toLowerCase()) {
    case "pending":
      return { bg: "bg-yellow-200", text: "text-yellow-900", fill: "fill-yellow-500" };
    case "ordered":
      return { bg: "bg-green-200", text: "text-green-900", fill: "fill-green-500" };
    case "shipped":
      return { bg: "bg-blue-200", text: "text-blue-900", fill: "fill-blue-500" };
    case "cancelled":
      return { bg: "bg-red-200", text: "text-red-900", fill: "fill-red-500" };
    case "in progress":
      return { bg: "bg-amber-200", text: "text-amber-900", fill: "fill-amber-500" };
    case "created":
      return { bg: "bg-pink-200", text: "text-pink-900", fill: "fill-pink-500" };
    case "delivered":
      return { bg: "bg-lime-200", text: "text-lime-900", fill: "fill-lime-500" };
    case "archived":
      return { bg: "bg-purple-200", text: "text-purple-900", fill: "fill-purple-500" };
    default:
      return { bg: "bg-gray-200", text: "text-gray-900", fill: "fill-gray-500" };
  }
}
//#endregion
